import script from "./ContactDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactDialog.vue?vue&type=script&setup=true&lang=js"

import "./ContactDialog.vue?vue&type=style&index=0&id=25349b99&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25349b99"]])

export default __exports__